export default "/arrow-left.0c94785df75c77561b1a63db33a7ef62.svg";